export interface ProgressSteps {
  init: number;
  precompute: number;
  apiLoad: number;
  maxSimulation: number;
  complete: number;
}

export interface SimulatedProgressOptions {
  step: number;
  interval: number;
}
